import { ACCESS_LEVELS } from '@/lib/consts.js'

import { __t } from '@/lib/helpers.js'
import { ROUTE_META_PARAMS } from '@/router/consts.js'

const shouldBeVisible = (store) => {
  const isFrenchCertificationEnabled = store.getters['business/isFrenchCertificationEnabled']
  return !isFrenchCertificationEnabled
}

export default {
  path: 'gifts-and-bundle-services',
  name: 'gifts-and-bundle-services',
  meta: {
    [ROUTE_META_PARAMS.ACCESS_LEVEL]: ACCESS_LEVELS.ADVANCED,
  },
  component: () => import('@/views/business/gifts-and-bundle-services/index.vue'),
  children: [
    {
      path: 'gift-cards',
      name: 'gift-cards',
      meta: {
        title: __t('routes.gifts.gift-cards.title'),
        subtitle: __t('routes.gifts.gift-cards.subtitle'),
        hintKey: 'hintFeatureGiftCards',
      },
      component: () => import('@/views/business/gifts-and-bundle-services/gifts-route.vue'),
    },
    {
      path: 'memberships',
      name: 'memberships',
      meta: {
        title: __t('routes.gifts.memberships.title'),
        subtitle: __t('routes.gifts.memberships.subtitle'),
        hintKey: 'hintFeatureMemberships',
        [ROUTE_META_PARAMS.SHOULD_BE_VISIBLE]: shouldBeVisible,
      },
      component: () => import('@/views/business/gifts-and-bundle-services/gifts-route.vue'),
    },
    {
      path: 'packages',
      name: 'packages',
      meta: {
        title: __t('routes.gifts.packages.title'),
        subtitle: __t('routes.gifts.packages.subtitle'),
        hintKey: 'hintFeaturePackages',
        [ROUTE_META_PARAMS.SHOULD_BE_VISIBLE]: shouldBeVisible,
      },
      component: () => import('@/views/business/gifts-and-bundle-services/gifts-route.vue'),
    },
  ],
}
